const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const backendURL = process.env.REACT_APP_API ? process.env.REACT_APP_API : 'localhost:8080';
const secure =
  process.env.REACT_APP_SECURE && process.env.REACT_APP_SECURE === 'true' ? true : false;

const httpProtocol = secure ? 'https://' : 'http://';
const wsProtocol = secure ? 'wss://' : 'ws://';

const BACKEND_URL = isDevelopment ? httpProtocol + 'localhost:8080' : httpProtocol + backendURL;
const WS_API_URL = isDevelopment
  ? wsProtocol + 'localhost:8080/query'
  : wsProtocol + backendURL + '/query';
const GRAPHQL_API_URL = isDevelopment
  ? httpProtocol + 'localhost:8080/query'
  : httpProtocol + backendURL + '/query';

const version = 'v1.15.0';

const config = {
  backend_url: BACKEND_URL,
  ws_api_url: WS_API_URL,
  graphql_api_url: GRAPHQL_API_URL,
  version: version,
};

export default config;
